import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TiktokPostsComponent } from './Components/tiktok-posts/tiktok-posts.component';


export const tiktokRouting: Routes = [
  {
    path: '',
    component: TiktokPostsComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(tiktokRouting)],
  exports: [RouterModule],
})
export class TiktokRoutingModule {}
